import { PetBackend } from "src/app/backend/api/pet.backend";
import { PopupService } from "src/app/services/popup/popup.service";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Pet } from "src/app/backend/models/pet/pet";
import { lastValueFrom } from "rxjs";
import { dateUtil } from "src/app/support/date-util";

type CreateData = { weight: number; createdAt: string };

export async function registerPatientWeightFunction(
  patient: Pet,
  patientBackend: PetBackend,
  popupService: PopupService
): Promise<void> {
  await popupService.createEntity<CreateData>({
    title: sntTranslate(marker("Registra peso")),
    modalConfig: {
      height: 160
    },
    initialFormData: {
      createdAt: dateUtil().toISOString(),
      weight: 0
    },
    formItems: [
      {
        dataField: "createdAt",
        editorType: "dxDateBox",
        editorOptions: {
          min: patient.birthday || undefined,
          max: dateUtil().toISOString()
        },
        label: { text: sntTranslate(marker("Data di registrazione")) }
      },
      {
        dataField: "weight",
        editorType: "dxNumberBox",
        editorOptions: {
          step: 0,
          min: 0,
          format: {
            type: "decimal",
            precision: 2
          }
        },
        label: { text: sntTranslate(marker("Peso")) }
      }
    ],
    create: async (data) => {
      await lastValueFrom(
        patientBackend.weighing(
          patient.id,
          data.weight,
          dateUtil(data.createdAt).toISOString()
        )
      );
    }
  });
}
